import type { ForcePresetBody } from '../api/catalog';
import { ca } from '../i18n/ca';

/**
 * A composition's footprint: every object as a dot, scaled to fit a fixed
 * square. Not a photograph — the dots are the objects' own offsets, which the
 * platform can honestly draw, and enough to tell a checkpoint from a camp.
 */
export function CompositionFootprint({
  body,
  size = 96,
}: {
  body: ForcePresetBody;
  size?: number;
}) {
  const objects = body.objects ?? [];
  const reach = Math.max(
    4,
    ...objects.map((o) => Math.hypot(o.offset?.[0] ?? 0, o.offset?.[1] ?? 0)),
  );
  const half = size / 2;
  const scale = (half - 4) / reach;
  return (
    <svg
      className="composition-footprint"
      width={size}
      height={size}
      viewBox={`0 0 ${size} ${size}`}
      role="img"
      aria-label={ca.catalogPage2.compositionObjects(objects.length)}
    >
      <circle cx={half} cy={half} r={half - 1} className="edge" />
      {objects.map((o, i) => (
        <rect
          key={i}
          x={half + (o.offset?.[0] ?? 0) * scale - 1.5}
          // The map's y grows north and the picture's grows down.
          y={half - (o.offset?.[1] ?? 0) * scale - 1.5}
          width={3}
          height={3}
        />
      ))}
    </svg>
  );
}
